import { IAccountMappingTemplateGroup } from '@modeso/types__aumico-lib-annualreport-be';

export interface IGroupParentGroupAndIndexes {
    parentGroup: IAccountMappingTemplateGroup;
    indexInGroups: number;
    indexInSortedItems: number;
}
